import { IconCoupons } from './IconCoupons'

export default IconCoupons
